import { NuxtAxiosInstance } from '@nuxtjs/axios';
import { mapToChatMessageStatus } from './mapper';
import type { ChatMessageStatus } from '~/models/career/chatMessageStatus/type';

export const fetchChatMessageStatus = async (
  $axios: NuxtAxiosInstance
): Promise<ChatMessageStatus> => {
  const { data } = await $axios.get('/v1/career/chat_message_status');
  return mapToChatMessageStatus(data);
};
